import React from 'react';
import styled from 'styled-components';
import CopyClip from '../common/CopyClip';
import FavoritePin from '../common/FavoritePin';

const HoverItems = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  white-space: nowrap;
  cursor: default;
  justify-content: end;
  column-gap: 16px;
  white-space: nowrap;
`;

const HoverMenu = (props): JSX.Element => {
  const { id, url } = props;
  return (
    <HoverItems id={`hover-item-${id}`}>
      <FavoritePin width={32} {...props} />
      <CopyClip width={32} height={32} pathname={url} />
    </HoverItems>
  );
};

export default HoverMenu;
